import { api, React } from '@/app'
import { APIClient } from '@/services'
import { useDebounce } from '@codeleap/common'
import { useQuery } from '@tanstack/react-query'

function checkReferralCode(referral_code: string) {
  if (!referral_code || referral_code.length === 0) return null

  return api.post('profiles/check_referral_code/', { referral_code })
}

export function useReferralCode(referralCode: string) {
  const [debouncedReferralCode] = useDebounce(referralCode, 500)

  const query = useQuery(
    {
      queryKey: ['referralCode', debouncedReferralCode],
      queryFn: async () => checkReferralCode(debouncedReferralCode),
      enabled: !!debouncedReferralCode && debouncedReferralCode.length > 0,
      retry: false
    },
    APIClient.queryClient.client
  )

  const hasReferralCode = React.useDeferredValue(debouncedReferralCode?.length > 0)
  const isLoading = React.useDeferredValue(hasReferralCode && query.isLoading)
  const isValid = React.useDeferredValue(hasReferralCode ? query.isFetched && !query.isError : true)

  return {
    query,
    isValid,
    isLoading,
    data: query.data
  }
}
